import React, { useState, useEffect, useMemo, Activity } from 'react';

// third party
import { IntlProvider, MessageFormatElement } from 'react-intl';
import useConfig from 'hooks/useConfig';

// types
import { I18n } from 'types/config';

// load locales files
function loadLocaleData(i18n: I18n) {
  switch (i18n) {
    case 'fr':
      return import('utils/locales/fr.json');
    case 'ro':
      return import('utils/locales/ro.json');
    case 'zh':
      return import('utils/locales/zh.json');
    case 'en':
      return import('utils/locales/en.json');
    default:
      return import('utils/locales/hu.json');
  }
}

// ==============================|| LOCALIZATION ||============================== //

interface LocalsProps {
  children: React.ReactNode;
}

export default function Locales({ children }: LocalsProps) {
  const {
    state: { i18n }
  } = useConfig();
  const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();

  const localeDataPromise = useMemo(() => loadLocaleData(i18n), [i18n]);
  useEffect(() => {
    localeDataPromise.then((d: { default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined }) => {
      setMessages(d.default);
    });
  }, [localeDataPromise]);

  return (
    <>
      <Activity mode={messages ? 'visible' : 'hidden'}>
        <IntlProvider
          locale={i18n}
          defaultLocale="hu"
          messages={messages}
          onError={() => {
            // suppress MISSING_TRANSLATION warnings — defaultMessage is provided at call sites
          }}
        >
          {children}
        </IntlProvider>
      </Activity>
    </>
  );
}
